import React from 'react'
import { css } from '@emotion/react'
import { string, object, bool } from 'prop-types'

import Designation from '@/components/Product/Designation'
import PaymentLabel from './PaymentLabel'
import Rating from './Rating'
import Badge from './Badge'

const infoCss = css`
  white-space: nowrap;
  max-width: 100%;
`

const subtitleCss = css`
  display: flex;
  max-height: 20px;
  justify-content: start;
  align-items: center;
  line-height: 20px;
  margin-bottom: 2px;
  gap: 0.25rem;

  .product-badge {
    margin-right: 0;
    overflow: visible;
    text-overflow: initial;
  }
`

const subInfoCss = ({ colors }) => css`
  display: flex;
  flex-flow: row wrap;
  height: 20px;
  overflow: hidden;
  color: ${colors.primary};
  opacity: 0.7;

  span {
    font-size: 12px;

    span {
      opacity: initial;
    }
  }
`

const Subtitle = ({
  designation,
  payment,
  rating,
  id,
  isTutorialApp,
  isAiApplication,
}) => {
  return (
    <div css={infoCss}>
      <div css={subtitleCss}>
        <Badge id={id} noVerified withAiBadge={isAiApplication} />

        {!isTutorialApp && (
          <div css={subInfoCss}>
            <PaymentLabel payment={payment} defaultCurrencySign />
            <Rating rating={rating} />
          </div>
        )}
      </div>

      <Designation product={designation} variant="card" />
    </div>
  )
}

Subtitle.propTypes = {
  designation: string,
  payment: object,
  rating: object,
  id: string,
  isTutorialApp: bool,
  isAiApplication: bool,
}

export default Subtitle
